export default "__VITE_ASSET__DXbFa5gi__"